import { render, staticRenderFns } from "./RenamePolicy.vue?vue&type=template&id=39f59b6e&"
import script from "./RenamePolicy.vue?vue&type=script&lang=js&"
export * from "./RenamePolicy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports